import { useEffect, useState } from "react"
import { arrayOf, shape, number } from "prop-types"
import { Button, StackView } from "@planningcenter/tapestry-react"
import AttendeeCheckbox from "./AttendeeCheckbox"

const WaitlistedAttendees = ({ attendees }) => {
  const [selectedAttendees, setSelectedAttendees] = useState({})
  const handleSelect = id => {
    return event => {
      setSelectedAttendees(currentSelections => ({
        ...currentSelections,
        [id]: event.target.checked
      }))
    }
  }

  // If attendees changes, update selectedAttendees to only include those that are still in the list
  useEffect(() => {
    setSelectedAttendees(currentSelections =>
      Object.fromEntries(
        Object.entries(currentSelections).filter(([id]) =>
          attendees.some(attendee => attendee.id === Number(id))
        )
      )
    )
  }, [attendees])

  const anyAttendeesChecked = () => Object.values(selectedAttendees).some(value => value)

  return (
    <>
      <div className="d-f ai-c jc-sb mb-2">
        <h1 className="h4 fw-600 mb-0">Waitlist</h1>
        <Button
          title="Promote"
          size="xs"
          theme="create"
          variant="outline"
          disabled={!anyAttendeesChecked()}
        />
      </div>
      <StackView gap={2}>
        {attendees.map(attendee => (
          <AttendeeCheckbox
            key={attendee.id}
            attendee={attendee}
            checked={!!selectedAttendees[attendee.id]}
            onSelect={handleSelect(attendee.id)}
          />
        ))}
      </StackView>
    </>
  )
}

WaitlistedAttendees.propTypes = {
  attendees: arrayOf(
    shape({
      id: number
    })
  )
}

export default WaitlistedAttendees
